/**
 * Shared macro metadata for the custom meal form. Tailwind classes are kept as
 * full literals so the NativeWind compiler can pick them up (dynamic `bg-${x}`
 * class names are NOT supported).
 */
export type MacroKey = 'protein' | 'carbs' | 'fats' | 'fibre';

export interface MacroMeta {
  key: MacroKey;
  /** Full literal background class for the colour dot / bar segment. */
  bgClass: string;
  /** i18n key (meal namespace) for the macro label. */
  labelKey: string;
}

export const MACROS: MacroMeta[] = [
  {
    key: 'protein',
    bgClass: 'bg-macro-protein',
    labelKey: 'nutrition.protein.longLabel',
  },
  {
    key: 'carbs',
    bgClass: 'bg-macro-carbs',
    labelKey: 'nutrition.carbs.longLabel',
  },
  {
    key: 'fats',
    bgClass: 'bg-macro-fats',
    labelKey: 'nutrition.fats.longLabel',
  },
  {
    key: 'fibre',
    bgClass: 'bg-macro-fibre',
    labelKey: 'nutrition.fiber.longLabel',
  },
];

/** Macros shown in the distribution bar (fibre is excluded), with kcal/g factors. */
export const ENERGY_MACROS: {
  key: 'protein' | 'carbs' | 'fats';
  bgClass: string;
  kcalPerGram: number;
}[] = [
  { key: 'protein', bgClass: 'bg-macro-protein', kcalPerGram: 4 },
  { key: 'carbs', bgClass: 'bg-macro-carbs', kcalPerGram: 4 },
  { key: 'fats', bgClass: 'bg-macro-fats', kcalPerGram: 9 },
];

/**
 * Shared className for filled text fields, matching the sport-activity form
 * ([SportActivityFormDialog]). Append `border border-negative` for errors.
 */
export const FIELD_INPUT_CLASS = 'h-12 rounded-xl bg-surface-elevated px-4';

/** Parse a numeric form value that may arrive as string or number. */
export const toNumber = (value: unknown): number => {
  const n = typeof value === 'number' ? value : parseFloat(String(value));
  return Number.isFinite(n) ? n : 0;
};
